import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html, $document } from './utils/environment';

window.app = {
    menuOpen: false
}

window.addEventListener('load', () => {
    document.documentElement.scrollTop = 0;

    requestAnimationFrame(() => {
        const app = new modular({
            modules: modules
        });

        app.init(app);
        globals();

        let isDesktopResolution = window.innerWidth > 1200
        window.addEventListener('resize', () => {
            if(isDesktopResolution && window.innerWidth <= 1200) location.reload()
            if(!isDesktopResolution && window.innerWidth > 1200) location.reload()
        })

        html.classList.add('is-loaded');
        html.classList.add('is-ready')
        html.classList.add('is-first-blood')
        html.classList.remove('is-loading');

        // Add youtube API
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = () => {
            window.ytAPIReady = true;
            $document.triggerHandler('ytAPIReady');
        }
    })
})
